import { MShopShareFramePopUpF } from '../../../MShop/ShareFrame/PopUp/F/Function/module/MShopShareFramePopUpF.js';
import { MShopUtilF } from '../../../MShop/Util/F/Function/module/MShopUtilF.js';
import {
  $addClass,
  $closest,
  $data,
  $delegate,
  $find,
  $hasClass,
  $on,
  $qs,
  $qsa,
  $removeClass,
  $setAttr,
  $setText,
  $siblings,
  $trigger,
} from 'fxdom/es';
import { NESS_CUSTOM_USER_PRODUCT_LIST_URL } from '../../../Ness/S/Constant/custom.js';
import { NessLabsSettingF } from '../../Setting/F/Function/module/NessLabsSettingF.js';
import { chunk, each, filter, find, go, identity, map, mapC, unzip } from 'fxjs/es';
import { NessLabsF } from './module/NessLabsF.js';
import { NessLabsS } from '../../S/Function/module/NessLabsS.js';
import { setMakerImageInCharacter, setProductPrice } from './product.js';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { VectorEditorConstantS } from '../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { MShopAppProductDetailMuiF } from '../../../MShop/App/ProductDetail/F/Mui/module/MShopAppProductDetailMuiF.js';
import { ConfigSentryF } from '../../../Config/Sentry/F/Function/module/ConfigSentryF.js';
import { UtilF } from '../../../Util/F/Function/module/UtilF.js';
import { NessUtilF } from '../../../Ness/Util/F/Function/module/NessUtilF.js';

/**
 * ### Labs Product Detail 페이지 전용 이벤트 초기화
 */
export const initNessLabsProductDetailEvents = async (tab_el) => {
  // 우클릭 방지
  document.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });

  const is_character_wrap = go(tab_el, $find('.mp-product-img-bg-wrap[data-is_character="true"]'));

  if (is_character_wrap) {
    is_character_wrap.addEventListener(
      'touchstart',
      function (e) {
        e.preventDefault();
      },
      { passive: false },
    );
  }

  const params = new URLSearchParams(location.search);
  const hasPcId = params.has('pc_id');

  let character = box().character; // 장바구니된(hasPcId) 상품이라면 character 는 snapshot 된 캐릭터가 됨.
  const selected_character = hasPcId ? box().selected_character : box().character;

  if (character) {
    if (await setMakerImageInCharacter(character)) {
      loadProductDetail(tab_el, character).then(async () => {
        if (hasPcId ? await setMakerImageInCharacter(selected_character) : selected_character) {
          await loadRecommendProductList(tab_el, selected_character);
        }
      });
    }
  } else {
    NessLabsF.labs_loader.end();
    if (box.sel('is_user->type') === 'CUSTOMER') {
      await MShopShareFramePopUpF.alert({
        body: ET('labs::character_not_selected::message'),
      });
      return (window.location.href = NESS_CUSTOM_USER_PRODUCT_LIST_URL());
    }
  }

  if (MShopUtilF.isMobile())
    new Swiper('.maple-labs-recommend__swiper', {
      slidesPerView: 'auto',
    });

  go(
    tab_el,
    $delegate('click', '.change_motion', async (e) => {
      if (!box.sel('is_user->type') || box.sel('is_user->type') == 'TEMP') {
        await MShopAppProductDetailMuiF.handleLoginRequirement();
        return;
      }
      const is_mobile = MShopUtilF.isMobile();

      NessLabsSettingF.openSetting(character, async (new_character) => {
        character = new_character;
        box().character = new_character;
        loadProductDetail(tab_el, character, true);
      });
    }),
  );

  go(
    tab_el,
    $delegate('click', '.product-detail_cate_header .labs__category__item', ({ currentTarget: ct }) => {
      const search_params = new URLSearchParams();
      search_params.set('cate_list_id', ct?.dataset.id);

      window.location.href = `${NESS_CUSTOM_USER_PRODUCT_LIST_URL()}?${search_params}`;
    }),
  );
};

async function setProductDetailCompositeThumbnail({
  el,
  product,
  cache_thumbnails,
  maker_type,
  thumbnail_size,
  character,
}) {
  if (!$hasClass('is_not_yet', el)) return;
  const composite_template_id = el.dataset.composite_template_id;
  const cache_thumbnail_custom_id = `${el.dataset.composite_template_id}${product.id}${product.product_faces2.maple_labs_design_hash}`;
  await go(el, $find('img'), async (img_el) => {
    const cached_url = cache_thumbnails[cache_thumbnail_custom_id];
    if (cached_url) {
      changeImgSrc(img_el, cached_url, el);
    } else {
      const thumb = composite_template_id
        ? go(
            product.thumbnails.value,
            find((thumb) => {
              return thumb.composite_template_id == composite_template_id;
            }),
          )
        : product.thumbnails.value[0];
      if (
        !(await NessLabsF.setCompositeThumbnail({
          thumb,
          product,
          with_design_ready_url: true,
          thumbnail_size,
          maker_type,
          character,
          composite_template_id,
        }))
      )
        return;
      changeImgSrc(img_el, thumb.url, el);
      cache_thumbnails[cache_thumbnail_custom_id] = thumb.url;
    }
  });
}

async function setProductDetailCharacterThumbnail(el, url) {
  if (!$hasClass('is_not_yet', el)) return;
  await go(el, $find('img'), async (img_el) => {
    changeImgSrc(img_el, url, el);
  });
}

async function setCharacterThumbnail(thumbnails, character) {
  const character_image_url = (
    await NessLabsS.getScaleUpCanvasPixelated(character._maple_image_url_with_motion, 900)
  ).toDataURL();
  const thumb = go(
    thumbnails.value,
    find((thumb) => thumb.is_character),
  );
  thumb.url = character_image_url;
  thumb.is_not_yet = false;
  return character_image_url;
}

function setSelectedOptionGroup(product, selected_option_group, maker_type) {
  function sizeString(fitted_size) {
    return `${fitted_size.width} x ${fitted_size.height} mm`;
  }

  if (VectorEditorConstantS.KEYRING_EDITOR === maker_type) {
    selected_option_group.title = go(
      product.product_faces2.value[0].designs,
      map((cv_obj) => cv_obj._data.fitted_size),
      filter(identity),
      map(sizeString),
      (arr) => (arr?.length === 2 ? `${arr[0]}, ${arr[1]}` : arr[0]),
    );
  } else if (VectorEditorConstantS.ACRYLIC_FIGURE_EDITOR === maker_type) {
    const stand_bottom_size = 3;
    selected_option_group.title = sizeString({
      width: product.product_faces2.value[0].designs[0]._data.fitted_size.width,
      height: product.product_faces2.value[0].designs[0]._data.fitted_size.height + stand_bottom_size,
    });
  }
  selected_option_group.id = null;
}

export const loadProductDetail = async (tab_el, character, forceRefresh = false) => {
  try {
    const { product_color: product, base_product, selected_option_group } = box().product_detail;
    const { original_product_faces2 } = box();
    NessLabsF.labs_loader.start();
    const cache_thumbnails = {};
    if (forceRefresh) {
      if (!(await setMakerImageInCharacter(character))) {
        NessLabsF.labs_loader.end();
        return;
      }
    }
    const maker_type = base_product.maker_type;

    const data = await NessLabsF.setProductFace({
      product,
      maker_type,
      character,
      selected_option_group,
      original_product_faces2,
    });
    if (!data) {
      if (!box().stop_load) NessLabsF.labs_loader.end();
      return;
    }
    if (
      [VectorEditorConstantS.KEYRING_EDITOR, VectorEditorConstantS.ACRYLIC_FIGURE_EDITOR].includes(maker_type)
    ) {
      box.set('svg_product_materials', data.svg_product_materials);
      setSelectedOptionGroup(product, selected_option_group, maker_type);
      box.set('selected_option_group', selected_option_group);
      const is_done = await setProductPrice(product, (price) => {
        const price_el = $qs('[name="price"]');
        price_el.value = price;
        go(
          price_el,
          $siblings('.pd-product__price-number'),
          each($setAttr({ has_tilde: false })),
          each($setText(UtilS.commify(price))),
        );
        const quantity_el = $qs('[name="quantity"]');
        if (quantity_el) {
          $trigger('change', quantity_el);
        }
        const total_price_el = $qs('.pd-total__price');
        if (total_price_el) {
          go(total_price_el, $setAttr({ has_tilde: false }));
        }
        if (box.sel('selected_option_group')) {
          const option_name = box.sel('selected_option_group')['title' + G._en];
          const base_name = base_product['name_creator' + G._en] ?? base_product['name' + G._en];
          const bp_name_el = $qs('.pd-product__bp-name');
          if (bp_name_el) {
            go(bp_name_el, $setText(base_name + ' - ' + option_name));
          }
        }

        NessLabsF.labs_loader.addTask(() => {
          MShopUtilF.popToastMsg('크기에 맞게 가격이 변동되었습니다.', 'info', { has_bottom_margin: true });
        });
      });
      if (!is_done) {
        $.alert('가격 설정에 문제가 발생했습니다.');
        return;
      }
    }

    const character_image_url = await setCharacterThumbnail(product.thumbnails, character);

    function _setThumbnail() {
      return mapC(
        each(async (el) => {
          if (el.dataset.is_character === 'true') {
            await setProductDetailCharacterThumbnail(el, character_image_url);
          } else {
            await setProductDetailCompositeThumbnail({
              el,
              product,
              cache_thumbnails,
              maker_type,
              thumbnail_size: 900,
              character,
            });
          }
        }),
      );
    }

    if (box().stop_load) return;

    if (MShopUtilF.isMobile()) {
      await go(
        $qsa('.pd-contents__preview  .mp-product-img-bg-wrap', tab_el),
        forceRefresh ? each($addClass('is_not_yet')) : identity,
        chunk(2),
        _setThumbnail(),
      );
    } else {
      await go(
        [
          $qsa('.pd-preview__swiper .mp-product-img-bg-wrap', tab_el),
          $qsa('.pd-preview__thumbs .mp-product-img-bg-wrap', tab_el),
        ],
        unzip,
        forceRefresh ? mapC(each($addClass('is_not_yet'))) : identity,
        _setThumbnail(),
      );
    }
  } catch (e) {
    ConfigSentryF.error(e);
    if (!box().stop_load) NessLabsF.labs_loader.end();
  } finally {
    if (!box().stop_load) NessLabsF.labs_loader.end();
  }
};

const loadRecommendProductList = async (tab_el, character, forceRefresh = false) => {
  await go(
    $qsa('.maple-labs-recommend .mp-product-img-bg-wrap', tab_el),
    forceRefresh ? each($addClass('is_not_yet')) : identity,
    each(async (el) => {
      if (!$hasClass('is_not_yet', el)) return;

      const product = go(el, $closest('.maple-labs-recommend__product-list-item'), $data);
      const maker_type = product._.base_product.maker_type;
      await go(el, $find('img'), async (img_el) => {
        const thumb = go(
          product.thumbnails.value,
          find((thumb) => {
            return thumb.is_thumb;
          }),
        );
        const thumbnails = await NessLabsF.getCachedThumbnails({
          thumbnails: [thumb],
          product,
          character,
          size_px: 600,
          maker_type,
        });
        if (thumbnails) {
          thumb.url = thumbnails[0].url;
          thumb.is_not_yet = false;
        } else {
          if (
            !(await NessLabsF.setProductFace({
              product,
              maker_type,
              character,
              selected_option_group: product._.selected_option_group,
              original_product_faces2: product.product_faces2,
              is_thumb: true,
            }))
          )
            return;
          if (
            !(await NessLabsF.setCompositeThumbnail({
              thumb,
              product,
              maker_type,
              thumbnail_size: 600,
              character,
              composite_template_id: thumb.composite_template_id,
            }))
          )
            return;
        }

        changeImgSrc(img_el, thumb.url, el);
      });
    }),
  );
};

const changeImgSrc = (img_el, src, wrap_el) => {
  img_el.src = src;
  img_el.onload = () => {
    $removeClass('is_not_yet', wrap_el);
  };
};

/**
 * ### 페이지 이동으로 인해 API 작업이 모두 완료되지 않았음에도 이전 캐시를 사용해 페이지를 그려 비정상인 경우를 추적
 * 페이지를 캐시를 이용해 그리거나 작업이 모두 완료되지 않은 경우를 확인해 reload 시킴
 */
export const detectBFCacheAndReload = () => {
  if (NessUtilF.isMobile())
    $on('pagehide', () => {
      box().stop_load = true;
      document.body.classList.add('ness_labs_need_reload'); // $.alert 를 강제로 숨김
      NessLabsF.labs_loader.start();
    })(window);

  UtilF.initBackForward((persisted) => {
    if (persisted || $qs('.don_dialog_msg') || $qs('.is_not_yet')) {
      /**
       * ### stop_load 의 역할
       * - 실행중인 작업들을 중단, 재실행은 reload
       * - API 비정상 응답으로 인해 사용자가 불가피한 에러메세지를 봐야하는 경우를 제거하기 위함
       */
      box().stop_load = true;
      document.body.classList.add('ness_labs_need_reload'); // $.alert 를 강제로 숨김
      NessLabsF.labs_loader.start();
      setTimeout(
        () => {
          window.location.reload();
        },
        NessUtilF.isMobile() ? 500 : 0,
      );
    }
  });
};
